<script setup lang="ts">
defineProps<{ title?: string; collapsed: boolean }>();
</script>

<template>
  <section class="flex flex-col gap-[2px]">
    <!-- Title and separator share one cell so the collapse cross-fades them in place. grid-cols-1 keeps that
         cell at the menu's width: an auto column grows to the title and pushes the separator off-centre.
         Collapsed, the row shrinks to the separator plus 12 px, which with the 2 px item gap mirrors the 14 px section gap above. -->
    <div
      v-if="title"
      class="grid grid-cols-1 grid-rows-[minmax(0,1fr)] items-center overflow-hidden transition-[height,padding] duration-200 ease-out motion-reduce:transition-none"
      :class="collapsed ? 'h-[13px] pb-3' : 'h-6 pb-1.5 pt-1'"
    >
      <span
        class="section_title small_demi col-start-1 row-start-1 whitespace-nowrap pl-[10px] text-[11px] uppercase leading-[13px] tracking-[0.66px] text-secondary-color transition-opacity duration-200 ease-out motion-reduce:transition-none"
        :class="collapsed ? 'opacity-0' : 'opacity-70'"
      >
        {{ title }}
      </span>
      <span
        class="col-start-1 row-start-1 h-px w-6 justify-self-center bg-stroke-color transition-opacity duration-200 ease-out motion-reduce:transition-none"
        :class="collapsed ? 'opacity-100' : 'opacity-0'"
        aria-hidden="true"
      ></span>
    </div>
    <nav class="flex flex-col gap-[2px]">
      <slot />
    </nav>
  </section>
</template>
